import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PlanCards from "../components/PlanCards";
import { useAuth } from "../auth/AuthContext";
import "./Pricing.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PLAN_LABEL = { free: "Free", single_report: "Single Report", parish_pro: "Parish Pro", cathedral: "Cathedral", diocese: "Diocese" };

export default function Billing() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const ent = user?.entitlements || {};
  const planKey = ent.plan || "free";
  const isActive = ent.plan_status === "active";
  const [busy, setBusy] = useState(false);

  const openPortal = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/billing/portal`, { plan: "_", origin: window.location.origin });
      window.location.href = data.url;
    } catch (e) { alert(e.response?.data?.detail || "Could not open the billing portal."); setBusy(false); }
  };

  return (
    <div className="pricing" data-testid="billing-page">
      <header className="pricing-top">
        <button className="pricing-brand" onClick={() => navigate("/dashboard")}>Liturgical Intelligence™</button>
        <div className="pricing-nav"><button onClick={() => navigate("/account")} data-testid="billing-account">Account</button></div>
      </header>

      <section className="pricing-hero">
        <div className="pricing-eyebrow">Billing &amp; Plans</div>
        <h1>Your subscription</h1>
        <p>Current plan: <b data-testid="billing-current-plan">{PLAN_LABEL[planKey] || "Free"}</b> · {isActive ? "Active" : (ent.plan_status || "Inactive")}</p>
        {(planKey === "parish_pro" || planKey === "cathedral" || planKey === "diocese") && (
          <button className="pricing-fc-btn" style={{ marginTop: 16 }} onClick={openPortal} disabled={busy} data-testid="billing-portal">
            {busy ? "Opening…" : "Manage Billing"}
          </button>
        )}
      </section>

      <div className="pricing-plans">
        <PlanCards currentPlan={isActive ? planKey : null} />
      </div>
      <footer className="pricing-foot"><button onClick={() => navigate("/dashboard")}>← Back to Dashboard</button></footer>
    </div>
  );
}
